import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=428ff51b&"
import script from "./addComment.vue?vue&type=script&lang=js&"
export * from "./addComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports